/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Space,
  Text,
  Conditional,
  Button,
} from '@cashfree-intl/coherent';
import moment from 'moment';
import { DATE_AND_TIME_FORMAT, PLACEHOLDER_TEXT } from 'utils/constants';
import CustomIcon from 'components/CustomIcons';
import { titleCase } from 'utils/common';
import TimelineTable from 'components/TimelineTable';
import {
  DOC_STATUS_COLOR_MAPPING,
  DOC_STATUS_TEXT_MAPPING,
  VENDOR_DOCS_HEADING_DATA,
} from '../constants';
import { prepareVendorDocsTableData } from '../helpers';

const VendorKycDetailsV2 = ({
  vendorDocs,
  onFilePreviewClickHandler,
  onEditClickHandler,
}) => {
  const [rowData, setRowData] = useState([]);
  const headingData = VENDOR_DOCS_HEADING_DATA;

  const handleFilePreview = docName => () => {
    onFilePreviewClickHandler(docName);
  };

  useEffect(() => {
    if (vendorDocs?.documents?.length) {
      const formattedRowData = prepareVendorDocsTableData(
        vendorDocs?.documents,
      );

      const formattedData = formattedRowData.map(row => ({
        ...row,
        id: (
          <Text variant="b14" color="bodyLight">
            {row.docName}
          </Text>
        ),
        docStatus: row?.status,
        submittedOn: () => (
          <span>
            {row?.submittedOn
              ? moment(row?.submittedOn).format(DATE_AND_TIME_FORMAT)
              : PLACEHOLDER_TEXT}
          </span>
        ),
        docType: () => <span>{row?.docName}</span>,
        docVal: () => {
          if (row?.docType === 'input') {
            return <span>{row?.docVal || PLACEHOLDER_TEXT}</span>;
          }
          return (
            <>
              <Conditional if={!!row?.docVal}>
                <Space gap={1} alignItems="center">
                  <CustomIcon
                    componentName="FILE_FORMAT"
                    width="14"
                    height="16"
                  />
                  <Text color="primary">
                    {row?.docVal?.substring(0, 13)}...
                  </Text>
                  <div
                    className="pointer"
                    data-testid={`file-preview-${row.docName}`}
                    onClick={handleFilePreview(row.docName)}
                  >
                    <CustomIcon componentName="OPEN_NEW_TAB" />
                  </div>
                </Space>
              </Conditional>
              <Conditional if={!row?.docVal}>{PLACEHOLDER_TEXT}</Conditional>
            </>
          );
        },
        status: () => (
          <Text color={DOC_STATUS_COLOR_MAPPING[(row?.status)] || 'bodyLight'}>
            {(row?.status === 'ACTION_REQUIRED' &&
              !!row?.docVal &&
              DOC_STATUS_TEXT_MAPPING[(row?.status)]) ||
              titleCase(row?.status || PLACEHOLDER_TEXT)}
          </Text>
        ),
        remarks: () => (
          <Text color="bodyLight">
            {titleCase(row?.reason || PLACEHOLDER_TEXT)}
          </Text>
        ),
      }));
      setRowData(formattedData);
    }
  }, [vendorDocs]);

  const handleEditCTAClick = () => {
    onEditClickHandler('kycDetails');
  };

  const editCTA = () => {
    let ctaText = 'Edit';

    const allDocsStatus = rowData.map(row => {
      const { docStatus } = row;
      return docStatus;
    });

    if (allDocsStatus.includes('ACTION_REQUIRED')) {
      ctaText = 'Re-upload Docs';
    }

    const ctaType = ctaText === 'Edit' ? 'secondary' : 'primary';

    return (
      <Button variant={ctaType} size="small" onClick={handleEditCTAClick}>
        {ctaText === 'Edit' ? (
          <CustomIcon componentName="EDIT" className="mr-1" />
        ) : null}
        {ctaText}
      </Button>
    );
  };

  return (
    <Conditional if={rowData.length > 0}>
      <Paper>
        <Space justifyContent="space-between" alignItems="center">
          <Text variant="h16" strong>
            KYC Details
          </Text>
          {editCTA()}
        </Space>
        <div className="common-table-wrapper mt-3">
          <TimelineTable headingData={headingData} rowData={rowData} />
        </div>
      </Paper>
    </Conditional>
  );
};

VendorKycDetailsV2.propTypes = {
  vendorDocs: PropTypes.object,
  onFilePreviewClickHandler: PropTypes.func,
  onEditClickHandler: PropTypes.func,
};

export default VendorKycDetailsV2;
